import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useEffect } from 'react';


const PrivacyConfidentialityStatic = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Box sx={{
            p: '1rem',
            backgroundColor: '#DCF1F0'
        }}>

            <Box sx={{
                maxWidth: '85rem',
                margin: 'auto'
            }}>
                <Box sx={(theme) => ({
                    display: 'flex',
                    padding: 0,
                    alignItems: 'center',
                    justifyContent: 'center',
                    [`${theme.breakpoints.down('sm')}`]: {
                        flexDirection: 'column-reverse'
                    }
                })}>
                    <Typography sx={{ flexBasis: '70%' }}>
                        <>
                            <Typography variant='h5' sx={(theme) => ({
                                color: 'text.secondary',
                                fontSize: '2rem',
                                fontWeight: 'bold'
                            })}>
                                Privacy and Confidentiality
                            </Typography>
                            <Typography>
                                <p> MediRadar (mediradar.com) / MediRadar Limited is committed to ensuring the privacy and confidentiality of your personal information, and to protect it from unauthorised access and disclosure.</p>
                                <p> The purpose of this Privacy Policy is to clearly communicate to you how MediRadar Limited handles your personal information to provide you with services, and to comply with legal obligations. This Privacy Policy applies to all websites owned or operated by MediRadar Limited, as amended from time to time (the “Websites”).This Privacy Policy (together with our terms and conditions of use of the website will give you a better and more complete understanding of the type of personal information that MediRadar Limited holds about you and the way MediRadar Limited handles that information.</p>
                                <p> MediRadar Limited complies with the Data Protection Act 1998, and the General Data Protection Regulation 2016/679 (“GDPR”) and any local or European laws on data protection. as amended from time to time. MediRadar Limited and is registered as a data controller as defined in the GDPR with the data protection regulator in the UK, the Information Commissioner’s Office “ICO”), www.ico.org.uk.</p>
                            </Typography>
                            <br />
                            <Typography variant="h6">
                                How we use your information
                            </Typography>
                            <Typography>
                                <p> This privacy policy tells you what to expect when MediRadar Limited collects personal information. It applies to information we collect about:</p>
                                <ul>
                                    <li>
                                        <p>Visitors to our Websites.</p>
                                        <p>
                                            Visitors who visit our website to do an imaging facility search and price comparison.
                                        </p>
                                        <p> MediRadar Limited collects data on visitors to its Websites including usage and behaviour patterns via a third party service, Google Analytics (Google LLC). This is to review the number of visits to each part of the Website and how the user accessed the Website only. Information collected, which may contain Personal Information, includes:</p>
                                    </li>
                                    <li>
                                        <p>Date and time of visit.</p>
                                        <p>Pages accessed.</p>
                                        <p>Browser or mobile platform used to access the Website.</p>
                                        <p>Source used to find and access the Website (i.e. Google Search Engine); </p>
                                        <p>Location of the visitor (town level only).</p>
                                        <p>Search queries from external and internal search engines.</p>
                                        <p>Page interaction information including aggregated contact form completions; and technical information, including browser type and version, operating system and platform.</p>
                                        <p>When you use our Website, we do not attempt to identify you as an individual user and we will not collect personal information about you unless you specifically provide this to us.</p>
                                        <p>We may collect your personal information if you choose to provide this to us via an online form or by email. Examples are where you:</p>
                                        <p>Submit your details on our user forms.</p>
                                        <p>Register to receive email Newsletters.</p>
                                        <p>Make an enquiry via a telephone number displayed on the Website; or</p>
                                        <p>Send a written complaint or enquiry to our Data Protection Officer</p>
                                    </li>
                                </ul>
                            </Typography>
                        </>
                    </Typography>

                </Box>
            </Box>

        </Box>
    );
};

export default PrivacyConfidentialityStatic;